import React from 'react';
import { HexColorInput, HexColorPicker } from 'react-colorful';

import Swatch from './Swatch';

const DEFAULT_PRESET_COLORS = [
  '#E11D48',
  '#DB2777',
  '#C026D3',
  '#9333EA',
  '#7C3AED',
  '#4F46E5',
  '#2563EB',
  '#0284C7',
  '#0891B2',
  '#0D9488',
  '#059669',
  '#16A34A',
  '#65A30D',
  '#CA8A04',
  '#D97706',
  '#EA580C',
  '#DC2626',
  '#FFFFFF',
  '#FAFAFA',
  '#F5F5F5',
  '#E5E5E5',
  '#D4D4D4',
  '#A3A3A3',
  '#737373',
  '#525252',
  '#404040',
  '#262626',
  '#171717',
  '#0A0A0A',
  '#000000',
];

type Props = {
  value: string;
  onChange: (v: string) => void;
};
export default function Picker({ value, onChange }: Props) {
  return (
    <div className="p-1 space-y-1">
      <style>{`
        .react-colorful__pointer {
          width: 16px;
          height: 16px;
        }
        .react-colorful__saturation {
          margin-bottom: 0.25rem;
          border-radius: 4px;
        }
        .react-colorful__last-control {
          border-radius: 4px;
        }
        .react-colorful__hue-pointer {
          width: 4px;
          border-radius: 4px;
          height: 24px;
          cursor: col-resize;
        }
        .react-colorful__saturation-pointer {
          cursor: all-scroll;
        }
        .color-picker-input {
          padding: 0.25rem;
          border: 1px solid hsl(var(--border));
          border-radius: 4px;
          width: 100%;
          background: transparent;
          color: hsl(var(--foreground));
        }
      `}</style>
      <HexColorPicker color={value} onChange={onChange} />
      <Swatch paletteColors={DEFAULT_PRESET_COLORS} value={value} onChange={onChange} />
      <div className="pt-1">
        <HexColorInput prefixed color={value} onChange={onChange} className="color-picker-input" />
      </div>
    </div>
  );
}
